import React from 'react'
import PropTypes from 'prop-types'
import RadioItem from './RadioItem'

const Radio = ({ data }) => {
  return data.map((item, index) => (
    <RadioItem key={index} item={item} index={index} />
  ))
}

Radio.propTypes = {
  data: PropTypes.array,
}

export default Radio
